import { flowRight } from 'lodash';
import { withLayoutUpdate } from './with-layout-update';
import { withDirection } from './with-direction';
import { withErrorState } from './with-error-state';
import ProvisioningPage from '../containers/provisioning-page';
import { withProvisioning } from './with-provisioning';
import { withInvalidState } from './with-invalid-state';
import { withCommunitiesWindowResize } from './with-communities-window-resize';

export function withViewer(AppRoot) {
  return flowRight(
    withDirection,
    withErrorState,
    withProvisioning(ProvisioningPage),
    withInvalidState,
    withLayoutUpdate,
    withCommunitiesWindowResize,
  )(AppRoot);
}
